// extracted by mini-css-extract-plugin
module.exports = {"card":"RecommendationBlock_card__ey_E0","recBlockWrapper":"RecommendationBlock_recBlockWrapper__CdEx1"};